<wiz-hgroup
  #actionContainer
  width="100%"
  height="100%"
  class="insert clickable-widget"
  verticalAlign="center"
  style="padding: 3px;"
>

  <wiz-icon [visible]="isSelected" class="image-purple" style="font-size: 18px !important" [style.color]="color">bookmark</wiz-icon>
  <wiz-icon #btnConf class="image-purple" style="font-size: 18px !important" (click)="doEdit()" [style.color]="color">edit</wiz-icon>


  <wiz-vgroup width="100%" gap="0">
    <wiz-label [wizLabel]="titleStr" 
    class="calendarLabel" width="100%" [wizTextBehavior]="'truncate'" 
    [tooltipText]="fullStr" wizForceTooltip="true" [style.color]="color"></wiz-label>
    <wiz-label [wizLabel]="contentStr" class="calendarLabel" width="100%" [wizTextBehavior]="'truncate'" 
    [tooltipText]="fullStr" wizForceTooltip="true" [style.color]="color"></wiz-label>
  </wiz-vgroup>

  <wiz-icon class="image-purple" style="font-size: 18px !important" (click)="doDelete()" [visible]="showDelete()"
  [style.color]="color">removal</wiz-icon>
</wiz-hgroup>
